<template>
  <v-dialog value="true" persistent max-width="630">
    <v-form ref="statusForm" v-model="localModalFormValid">
      <v-card class="SetToInProgressDialog pa-4">
        <v-btn
          @click="close"
          class="ma-0 primary--text status-close-btn"
          right
          absolute
          fab
          small
          color="white"
          depressed
          aria-label="Close set to in progress dialog"
          id="btn-close-set-to-in-progress"
        >
          <v-icon>close</v-icon>
        </v-btn>

        <v-container
          class="px-8 my-5"
          v-if="setToInProgressStatus === 'pending'"
        >
          <v-row justify="start" align="center">
            <h1>
              <span class="status-title-highlight">Set to In Progress</span> for
              {{ studentName }}?
            </h1>
          </v-row>
          <v-row justify="end" class="mt-5">
            <p>
              This application will be set to
              <strong>"In Progress"</strong> status and will be moved to the
              pending applications view.
            </p>
          </v-row>
          <v-row justify="end">
            <v-card>
              <OesCheckbox
                v-model="confirmStatusChange"
                class="mr-1"
                data-testid="confirm-status-change-checkbox"
              >
                <template #label>
                  <p>
                    I confirm that I want to set this application to
                    <strong>In Progress</strong> status.
                  </p>
                </template>
              </OesCheckbox>
            </v-card>
          </v-row>
          <v-row justify="end" class="mt-5">
            <v-btn
              color="primary status-btn"
              @click="setToInProgress"
              :disabled="!confirmStatusChange"
              data-testid="confirm-set-to-in-progress"
            >
              Confirm
            </v-btn>
          </v-row>
        </v-container>

        <v-container
          class="pl-5 pr-5 pb-0 pt-0"
          v-if="setToInProgressStatus === 'completed'"
        >
          <v-row justify="start" align="center">
            <v-col cols="1" class="align-center justify-center d-flex pa-0">
              <v-avatar color="success" size="40">
                <v-icon color="white" size="34">mdi-check-circle</v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="11">
              <h1>Status updated successfully</h1>
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-col cols="11">
              <p>
                The application has been successfully set to
                <strong>In Progress</strong> status.
              </p>
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-btn color="primary" @click="close">Close</v-btn>
          </v-row>
        </v-container>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import OesCheckbox from '@/components/app/OesCheckbox'

export default {
  name: 'SetToInProgressDialog',
  components: {
    OesCheckbox
  },
  data() {
    return {
      confirmStatusChange: false,
      localModalFormValid: true
    }
  },
  computed: {
    application() {
      return this.$store.state.application
    },
    setToInProgressStatus() {
      return this.$store.state.setToInProgressStatus
    },
    studentName() {
      const firstName = this.application?.student?.firstName || ''
      const familyName = this.application?.student?.familyName || ''

      if (firstName || familyName) {
        return (firstName + ' ' + familyName).trim()
      }
      return 'this student'
    }
  },
  methods: {
    close() {
      this.$store.dispatch('set', ['openSetToInProgressModal', false])
      this.$store.dispatch('set', ['setToInProgressStatus', null])
      this.confirmStatusChange = false
    },
    async setToInProgress() {
      const IN_PROGRESS_STATUS_ID = 2

      try {
        await this.$store.dispatch('saveCoreApplicationStatus', {
          applicationStatusId: IN_PROGRESS_STATUS_ID
        })

        // Update UI state to show success message
        this.$store.dispatch('set', ['setToInProgressStatus', 'completed'])
      } catch (error) {
        // Error handling is done in the action itself via genericApiError
        // Close the modal on error
        this.close()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.SetToInProgressDialog {
  h1 {
    color: $color-primary;
    width: 90%;

    .status-title-highlight {
      color: $color-primary;
    }
  }
  .v-card {
    background: $grey-light-10;
    box-shadow: none;
    padding-left: 20px;

    ::v-deep .v-input__slot {
      align-items: initial;
    }

    ::v-deep .v-input--selection-controls__input .v-icon {
      color: $color-btn-disabled-text-default;
    }

    ::v-deep .v-input--selection-controls .v-input__slot > .v-label {
      color: $grey-dark;
    }
  }

  button.v-btn.status-close-btn {
    border: none;
    &:focus {
      box-shadow: 0 0 0 2px $color-focus !important;
    }
  }
  button.v-btn.status-btn {
    border: none;
    &:focus {
      box-shadow: 0 0 0 2px $color-focus !important;
    }
  }
}
</style>
